const variaveisComuns = [
  "apelidoFantasia",
  "nomeCompletoCliente",
  "primeiroNomeCliente",
  "nomeUsuario",
];

export const statusCobranca = [
  {
    status: "pre-vencimento-2",
    descricao: "Pré-vencimento II",
    disparo: "antes",
    diasPadrao: 7,
  },
  {
    status: "pre-vencimento",
    descricao: "Pré-vencimento I",
    disparo: "antes",
    diasPadrao: 3,
  },
  {
    status: "dia-vencimento",
    descricao: "Dia do Vencimento",
    disparo: "dia",
  },
  {
    status: "pos-vencimento-1",
    descricao: "Pós-vencimento I",
    disparo: "apos",
    diasPadrao: 3,
  },
  {
    status: "pos-vencimento-2",
    descricao: "Pós-vencimento II",
    disparo: "apos",
    diasPadrao: 7,
  },
];

export const contextosCobranca = statusCobranca.map((item) => ({
  label: `Contas a Receber - Cobrança (${item.descricao})`,
  value: `cobranca-automatizada-${item.status}`,
}));

export const contextosCobrancaComDias = statusCobranca
  .filter((item) => item.disparo !== "dia")
  .map((item) => `cobranca-automatizada-${item.status}`);

const contextosComStatus = ["ordem-servico", "cobranca-automatizada"];

export function getContextoBase(contexto) {
  const valor = contexto || "";
  return contextosComStatus.find((base) => valor.startsWith(base)) || valor;
}

export function getGatilhoCobranca(status, dias) {
  const item = statusCobranca.find((cobranca) => cobranca.status === status);
  if (!item) return "";
  if (item.disparo === "antes") {
    return `Dispara ${dias || item.diasPadrao} dias antes do vencimento`;
  }
  if (item.disparo === "apos") {
    return `Dispara ${dias || item.diasPadrao} dias após o vencimento`;
  }
  return "Dispara no dia do vencimento";
}

export const variaveisPorContexto = {
  condicional: [
    ...variaveisComuns,
    "numeroDocumento",
    "dataVencimento",
    "status",
  ],
  "nf-saida": [...variaveisComuns, "serieDocumento", "numeroDocumento"],
  orcamento: [...variaveisComuns, "serieDocumento", "numeroDocumento"],
  "orcamento-servico": [
    ...variaveisComuns,
    "serieDocumento",
    "numeroDocumento",
  ],
  "ordem-servico": [
    ...variaveisComuns,
    "serieDocumento",
    "numeroDocumento",
    "dataAbertura",
    "dataPrevistaFechamento",
    "dataFechamento",
    "status",
    "ativos",
    "observacoes",
  ],
  pedido: [...variaveisComuns, "serieDocumento", "numeroDocumento"],
  agendamentoServico: [
    ...variaveisComuns,
    "dataAgendamento",
    "horaAgendamento",
  ],
  lembreteAgendamentoServico: [
    ...variaveisComuns,
    "dataAgendamento",
    "horaAgendamento",
  ],
  aniversario: [...variaveisComuns, "dataNascimento"],
  "condicional-cobranca": [...variaveisComuns, "documentosAVencer"],
  "condicional-lembrete": [...variaveisComuns, "documentosAVencer"],
  "condicional-vencimento": [
    "apelidoFantasia",
    "nomeCompletoCliente",
    "primeiroNomeCliente",
    "dataVencimento",
    "condicionais",
  ],
  "conta-receber-cobranca": [...variaveisComuns, "documentosAVencer"],
  "conta-receber-lembrete": [...variaveisComuns, "documentosAVencer"],
  "cobranca-automatizada": [
    "apelidoFantasia",
    "nomeCompletoCliente",
    "primeiroNomeCliente",
    "numeroTitulo",
    "valorTitulo",
    "dataVencimentoTitulo",
    "titulos",
  ],
  campanha: [...variaveisComuns],
  "servico-recorrente": [
    ...variaveisComuns,
    "ativo",
    "dataVencimento",
    "nomeServico",
    "dataUltimaRecorrencia",
    "ordemServico",
    "quantidadeDias",
    "linkAgendamento",
  ],
  "boleto": [
    ...variaveisComuns,
    "tituloDocumento",
    "dataVencimento",
    "valorTotal",
    "status",
  ],
};

export function getVariaveisPorContexto(contexto, status) {
  const base = getContextoBase(contexto);

  const vars = variaveisPorContexto[base]
    ? [...variaveisPorContexto[base]]
    : [...variaveisComuns];

  if (base === "ordem-servico" && typeof status === "string") {
    if (status.toUpperCase() === "FECHADO") {
      if (!vars.includes("linkPesquisaSatisfacao")) {
        vars.push("linkPesquisaSatisfacao");
      }
    }
  }
  return vars;
}

export const variaveisDisponiveis = [
  ...new Set(Object.values(variaveisPorContexto).flat()),
];

export const contextosDisparoAutomatico = [
  "aniversario",
  "condicional-vencimento",
  "cobranca-automatizada",
];

export const contextosSemAnexo = [
  "condicional-vencimento",
  "cobranca-automatizada",
];

export const contextosLote = [
  {
    label: "Aniversário",
    value: "aniversario",
  },
  {
    label: "Condicional - Cobrança",
    value: "condicional-cobranca",
  },
  {
    label: "Condicional - Lembrete",
    value: "condicional-lembrete",
  },
  {
    label: "Conta Receber - Cobrança",
    value: "conta-receber-cobranca",
  },
  {
    label: "Conta Receber - Lembrete",
    value: "conta-receber-lembrete",
  },
  /*   {
    label: "Clientes",
    value: "clientes",
  }, */
  {
    label: "Campanha",
    value: "campanha",
  },
];

export const contextos = [
  {
    label: "Condicional",
    value: "condicional",
  },
  {
    label: "NF-Saída",
    value: "nf-saida",
  },
  {
    label: "Orçamento",
    value: "orcamento",
  },
  {
    label: "Orçamento (Serviço)",
    value: "orcamento-servico",
  },
  {
    label: "Ordem de Serviço",
    value: "ordem-servico",
  },
  {
    label: "Pedido",
    value: "pedido",
  },
  {
    label: "Agendamento (Serviço)",
    value: "agendamentoServico",
  },
  {
    label: "Lembrete Agendamento (Serviço)",
    value: "lembreteAgendamentoServico",
  },
  {
    label: "Serviço Recorrente",
    value: "servico-recorrente",
  },
  {
    label: "Aniversário",
    value: "aniversario"
  },
  {
    label: "Boleto",
    value: "boleto"
  },
  {
    label: "Condicional - Vencimento",
    value: "condicional-vencimento",
  },
  {
    label: "Contas a Receber - Cobranças Automatizadas",
    value: "cobranca-automatizada",
  }
];
